module.exports = class ValidationError extends Error {
  constructor(error) {
    super(error.message);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
    this.isValid = false;
    this.errorCode = error.code;
    this.field = error.field;
    this.data = error.data;
  }
};